import React, { useState, useEffect, useRef } from 'react';
import { uploadFaceImage } from '../api/admin';
import SimpleAlert from '../components/SimpleAlert';
import SealNameInput from '../components/SealNameInput';
import BusinessTypeInput from '../components/BusinessTypeInput';


import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from 'react-pdf';
import DocumentFileViewer from '../components/DocmentFileViewer';
// import dayjs from 'dayjs';

// 正确配置Worker路径，版本号一致1
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;

const defaultPartner = { is_legal_person: 0, name: '', id_number: '', share_ratio: '', face_status: '尚未识别', company_name: '', company_credit_code: '' };
const businessTypeOptions = [
  '印章新刻', '印章增刻', '印章损毁换刻', '印章更名换刻', '印章遗失补刻', '印章作废补刻'
];

// 美化样式
const labelStyle = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  marginBottom: 'clamp(4px, 1vw, 8px)',
  color: 'var(--text-color)',
  fontWeight: '500',
  fontSize: 'clamp(12px, 2.5vw, 14px)'
};
const lookStyle = {
  display: 'block',
  marginLeft: '5px',
  textAlign: 'left',
  color: '#FFFFFF',
  fontSize: 'clamp(9px, 3vw, 11px)',
  cursor: 'pointer',
  padding: '2px 6px',
  backgroundColor: '#b50213',
  borderRadius: '5px'
};
const errorStyle = {
  color: 'var(--danger-color)',
  fontSize: 'clamp(11px, 2.5vw, 12px)',
  marginTop: '4px',
  display: 'block'
};

export default function AdminOrderForm({ id, onBack, onSaved }) {
  const [form, setForm] = useState({
    name: '', type: '', customType: '', credit_code: '', contact: '', legal_person: '', phone: '', share_ratio: '',
    address: '', seal_names: '', business_type: '', should_verify_count: '', actual_verify_count: '',
    is_announcement: 0, announcement_date: '', announcement_paper: '', has_legal_partner: 0,
    agent: '', agent_phone: '', sms_receivers: '', remark: '', partners: [{ ...defaultPartner }],
    isNotSignFile: false,
    resolutionChecked: false, resolutionFile: null, resolutionUrl: '', resolutionName: '',
    situationChecked: false, situationFile: null, situationUrl: '', situationName: '',
    customize1Checked: false, customize1File: null, customize1Url: '', customize1Name: '',
    customize2Checked: false, customize2File: null, customize2Url: '', customize2Name: '',
    resolutionTime: null, resolutionAddress: '', resolutionHost: '',
    idempotency_key: ''
  });
  const [isShowSignComplete, setIsShowSignComplete] = useState(false);
  const [currentSelectFileType, setCurrentSelectFileType] = useState('');
  const [msg, setMsg] = useState('');
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ open: false, message: '', onConfirm: null });
  const [files, setFiles] = useState([]);
  const [activeFileIndex, setActiveFileIndex] = useState(0);
  const [statusList, setStatusList] = useState([]);
  const [filesDelIndex, setFilesDelIndex] = useState([]);

  
  const [fileItem, setFileItem] = useState("");
  const [fileItemShow, setFileItemShow] = useState(false);
  const [fileType, setFileType] = useState('pdf');
  const pdfForPreview = useRef();


  useEffect(() => {
    if (!id) {
      // 生成一次性 idempotency_key
      setForm(prev=>({...prev, idempotency_key: crypto.randomUUID()}));
    }

    if (id) {
      const token = localStorage.getItem('adminToken');
      fetch(`/api/admin/orderDetail/${id}`, {
        headers: { Authorization: 'Bearer ' + token }
      })
          .then(res => res.json())
          .then(data => {
            // 添加调试日志
            console.log('=== 数据加载调试信息 ===');
            console.log('订单ID:', id);
            console.log('partners数量:', data.partners ? data.partners.length : 0);
            if (data.partners && data.partners.length > 0) {
              console.log('第一个partner的face_verified_at:', data.partners[0].face_verified_at);
              console.log('第一个partner的face_status:', data.partners[0].face_status);
            }
            console.log('加载的数据:', data);

            // 处理自定义机构类型的显示
            const isCustomType = !['有限责任公司', '有限公司（独资）', '个体工商户', '个人独资企业', '普通合伙企业', '特殊的普通合伙企业', '有限合伙企业', '分支机构/分公司', '农民专业合作社', '党政机关', '事业单位', '部队及军事院校', '社会团体', '群团组织', '基层群众性自治组织'].includes(data.type);
            /* setIsShowSignComplete(data.isShowSignComplete);
             delete data.isShowSignComplete;*/
            setForm({
              ...data,
              partners: data.partners || [],
              type: isCustomType ? '自定义' : data.type,
              customType: isCustomType ? data.type : ''
            });
            /*文件*/
            // 构建文件列表
            const fileList = data.fileList.map(file => ({
              ...file,
              isUpdate: true
            }));
            // 设置文件列表
            setFiles(fileList);
            /* // 情况说明文件
             if (data.situationChecked && data.situationUrl) {
               fileList.push({
                 fileUrl: data.situationUrl,
                 fileName: data.situationName || '情况说明文件',
                 isUpdate:true,
                 fileContent: null,
               });
             }

             // 股东会决议文件
             if (data.resolutionChecked && data.resolutionUrl) {
               fileList.push({
                 fileUrl: data.resolutionUrl,
                 fileName: data.resolutionName || '股东会决议文件',
                 isUpdate:true,
                 fileContent: null,
               });
             }

             // 自定义文件1
             if (data.customize1Checked && data.customize1Url) {
               fileList.push({
                 fileUrl: data.customize1Url,
                 fileName: data.customize1Name || '自定义文件1',
                 isUpdate:true,
                 fileContent: null,
               });
             }

             // 自定义文件2
             if (data.customize2Checked && data.customize2Url) {
               fileList.push({
                 fileUrl: data.customize2Url,
                 fileName: data.customize2Name || '自定义文件2',
                 isUpdate:true,
                 fileContent: null,
               });
             }
   */

          });
    }
  }, [id]);

  // 校验函数
  const validate = () => {
    const errs = {};

    // 必填字段校验
    if (!form.name) errs.name = '机构名称必填';
    if (!form.type) errs.type = '机构类型必选';

    // if(!form.isNotSignFile && form.resolutionChecked){
    //   if (!form.resolutionTime) {
    //     errs.resolutionChecked = '决议/决定 必填';
    //   }
    // }

    if (form.type === '自定义' && !form.customType) errs.type = '请输入自定义机构类型';
    if (!form.legal_person) errs.legal_person = '法定代表人必填';
    if (!form.phone || !/^1[3-9]\d{9}$/.test(form.phone.trim())) errs.phone = '负责人电话必填且为11位手机号';
    if (!form.partners || form.partners.length === 0) errs.partners = '至少添加一名参与核验人员';

    // 可选字段格式校验（如果填写了才校验格式）
    if (form.credit_code && !/^[0-9A-Z]{18}$/.test(form.credit_code.trim())) {
      errs.credit_code = '统一社会信用代码必须为18位大写字母或数字';
    }
    if (form.sms_receivers) {
      const phones = form.sms_receivers.split('\n').map(s => s.trim()).filter(Boolean);
      for (let i = 0; i < phones.length; i++) {
        if (!/^1[3-9]\d{9}$/.test(phones[i])) {
          errs.sms_receivers = `第${i + 1}行手机号格式不正确`;
          break;
        }
      }
    }
    if (form.should_verify_count && isNaN(form.should_verify_count)) errs.should_verify_count = '应核验人数必须为数字';
    if (form.actual_verify_count && isNaN(form.actual_verify_count)) errs.actual_verify_count = '参与核验人数必须为数字';
    if (form.agent_phone && !/^[0-9]+$/.test(form.agent_phone)) errs.agent_phone = '经办人联系电话必须为数字';

    // 登报声明相关字段校验（如果选择了登报声明才校验）
    if (form.is_announcement === '1' || form.is_announcement === 1) {
      if (!form.announcement_date) errs.announcement_date = '见报日期必填';
      if (!form.announcement_paper) errs.announcement_paper = '报刊名称必填';
    }

    // 参与人校验
    form.partners.forEach((p, idx) => {
      if (!p.name) errs[`partner_name_${idx}`] = '姓名必填';
      if (!p.id_number || !/^\d{17}[\dXx]$/.test(p.id_number.trim())) {
        errs[`partner_id_${idx}`] = '身份证号格式不正确';
      }
      // 出资比例可选，但如果填写了必须是数字
      if (p.share_ratio && isNaN(p.share_ratio)) errs[`partner_share_${idx}`] = '出资比例必须为数字';

      // 法人单位信息校验（如果选择了法人股东才校验）
      if (p.is_legal_person === 1 || p.is_legal_person === '1') {
        if (!p.company_name) errs[`partner_company_name_${idx}`] = '法人单位名称必填';
        if (!p.company_credit_code || !/^[0-9A-Z]{18}$/.test(p.company_credit_code.trim())) {
          errs[`partner_company_credit_${idx}`] = '法人单位统一社会信用代码必须为18位大写字母或数字';
        }
      }
    });
    if (!form.isNotSignFile) {
      let count = 0;
      if (form.situationChecked && (form.situationFile || form.situationUrl)) {
        count += 1;
      }
      if (form.resolutionChecked && (form.resolutionFile || form.resolutionUrl)) {
        count += 1;
      }
      if (form.customize1Checked && (form.customize1File || form.customize1Url)) {
        count += 1;
      }
      if (form.customize2Checked && (form.customize2File || form.customize2Url)) {
        count += 1;
      }
      if (count === 0) errs.isNotSignFile = '签署文件至少上传一份';
      if (form.resolutionChecked && (!form.resolutionTime)) {
        errs.resolutionChecked = '决议/决定 日期 必填';
      }
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePartnerChange = (idx, key, value) => {
    console.log(idx, key, value,'sss');
    const partners = [...form.partners];
    partners[idx][key] = value;
    setForm(prev => ({ ...prev, partners }));
    // 这里修改一下,认证失败后将这个人在当前订单的签名删掉

    // // 判断一下当前key是否是认证失败
    // if("认证失败" == value){
    //   partners[idx].id
    //   partners[idx].
    // }

  };

  const addPartner = () => {
    setForm(prev => ({ ...prev, partners: [...prev.partners, { ...defaultPartner }] }));
  };

  const removePartner = idx => {
    if (form.partners.length <= 1) {
      setAlert({ open: true, message: '不可删除，因为至少需要一个人做人脸实名核验！' });
      return;
    }
    const partners = [...form.partners];
    partners.splice(idx, 1);
    setForm(prev => ({ ...prev, partners }));
  };

  const handleFaceImageUpload = async (idx, e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!id) {
      setAlert({ open: true, message: '请先保存订单，再上传底库照' });
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result.split(',')[1];
      try {
        const res = await uploadFaceImage(form.partners[idx].id, base64);
        setAlert({ open: true, message: res.message || '上传成功' });
        handlePartnerChange(idx, 'face_image_base64', base64);
      } catch (err) {
        setAlert({ open: true, message: '上传失败，请重试' });
      }
    };
    reader.readAsDataURL(file);
  };

  const handleZzjChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (type !== 'checkbox') return;
    if (name === 'resolutionChecked') {
      setForm(prev => ({ ...prev, resolutionFile: null, resolutionUrl: '', resolutionName: '' }));
      console.log(!form.isNotSignFile && form.resolutionChecked )
    } else if (name === 'situationChecked') {
      setForm(prev => ({ ...prev, situationFile: null, situationUrl: '', situationName: '' }));
    } else if (name === 'customize1Checked') {
      setForm(prev => ({ ...prev, customize1File: null, customize1Url: '', customize1Name: '' }));
    } else if (name === 'customize2Checked') {
      setForm(prev => ({ ...prev, customize2File: null, customize2Url: '', customize2Name: '' }));
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setMsg('');
    if (!validate()) {
      setMsg('请完善表单信息');
      return;
    }
    const token = localStorage.getItem('adminToken');

    // 处理自定义机构类型
    const submitData = { ...form };
    console.log('submitData', submitData)
    if (form.type === '自定义' && form.customType) {
      submitData.type = form.customType;
    }

    let body = {
      ...submitData,
      id,
      idempotency_key: form.idempotency_key,
      partners: form.partners.map(p => ({
        ...p,
        face_image_base64: p.face_image_base64 || '', // 保证有字段
        face_verified_at: p.face_verified_at || null // 保留验证时间
      }))
    };
    delete body.resolutionFile;
    delete body.situationFile;
    delete body.customize1File;
    delete body.customize2File;

    // 添加调试日志
    console.log('=== handleSubmit 调试信息 ===');
    console.log('订单ID:', id);
    console.log('partners数量:', form.partners.length);

    if (form.partners.length > 0) {
      console.log('第一个partner的face_verified_at:', form.partners[0].face_verified_at);
      console.log('第一个partner的face_status:', form.partners[0].face_status);
    }

    // 在这里过滤掉files中的数据
    /**
     * AdminOrderForm.jsx:340 Uncaught (in promise) TypeError: Cannot read properties of undefined (reading 'filter')
    at onSubmit (AdminOrderForm.jsx:340:31)

     */
    
    console.log('提交的body:', body);
    if(id){ // 说明是修改
      // body.is_sign_complete = null;
      body = await uploadFile(body, token);
      console.log('上传文件前的files',files);
    }
    
    
    /* if (!isShowSignComplete) {
       body.is_sign_complete = false;
     }*/
    /*上传已签章的文件*/
    for (let i = 0; i < files.length; i++) {
        const item = files[i];
        console.log(item.fileContent+"up"+item.isUpdate+"url"+item.fileUrl+"名称"+item.fileName, i);
        if (!item.isUpdate) {
          const fileUrl = await signupload(item.fileContent, token);
          if (!fileUrl) {
            setAlert({ open: true, message: '文件上传失败' });
            return;
          }
          files[i].fileUrl=fileUrl;
        }
      }

      console.log('最终的files',files);
      body.files=files;

    // 发送之前先把删除的文件下标传过去
    body.filesDelIndex=filesDelIndex;

    const res = await fetch(`/api/admin/addOrg`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    console.log(data,'data')
    if (data.orgId || data.flow_no) {
      // 思路保存成功后再去上传文件,然后重新修改保存
      setMsg('保存成功');
      body.id = data.orgId
      body.flow_no = data.flow_no;
      if(!id){
        // 新增的时候调用这个
        await uploadFileByInsert(body,token)
        // 上传完成后跳转到详情或返回列表
        if (onSaved) {
          onSaved(data.orgId);
        } else if (onBack) {
          onBack();
        }
      }
      // 修改订单时仍可在需要时使用 onBack
    } else {
      setMsg(data.message || '保存失败');
    }

  };

  const uploadFileByInsert = async (body,token) => {
        id = body.id;
        body = await uploadFile(body, token);
        console.log("修改后的上传body:{}",body)

        console.log('上传文件前的files',files);
        for (let i = 0; i < files.length; i++) {
            const item = files[i];
            console.log(item.fileContent+"up"+item.isUpdate+"url"+item.fileUrl+"名称"+item.fileName, i);
            if (!item.isUpdate) {
              const fileUrl = await signupload(item.fileContent, token);
              if (!fileUrl) {
                setAlert({ open: true, message: '文件上传失败' });
                return;
              }
              files[i].fileUrl=fileUrl;
            }
          }

          console.log('最终的files',files);
          body.files=files;

        // 进行修改
        const res = await fetch(`/api/admin/addOrg`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify(body)
        });
        const data = await res.json();
  }

  const uploadFile = async (body, token) => {
    console.log("uploadfile")
    if (form.isNotSignFile) {
      body = Object.assign(body, {
        isNotSignFile: true,
        resolutionChecked: false, resolutionUrl: '', resolutionName: '',
        situationChecked: false, situationUrl: '', situationName: '',
        customize1Checked: false, customize1Url: '', customize1Name: '',
        customize2Checked: false, customize2Url: '', customize2Name: '',
        resolutionTime: '', resolutionAddress: '', resolutionHost: ''
      });
      return body;
    }
    if (form.situationChecked) {
      // 上传文件
      let situationUrl = form.situationUrl;
      if (form.situationFile) {
        console.log("文件",form.situationFile);
        situationUrl = await upload(form.situationFile, token);
        if (!situationUrl) {
          setAlert({ open: true, message: '文件上传失败' });
          return;
        }
      }
      body = Object.assign(body, {
        isNotSignFile: false,
        situationChecked: true, situationUrl
      });
    } else {
      body = Object.assign(body, {
        isNotSignFile: false,
        situationChecked: false, situationUrl: '', situationName: ''
      });
    }
    if (form.resolutionChecked) {
      // 上传文件
      let resolutionUrl = form.resolutionUrl;
      if (form.resolutionFile) {
        resolutionUrl = await upload(form.resolutionFile, token);
        if (!resolutionUrl) {
          setAlert({ open: true, message: '文件上传失败' });
          return;
        }
      }
      body = Object.assign(body, {
        isNotSignFile: false,
        resolutionChecked: true, resolutionUrl
      });
    } else {
      body = Object.assign(body, {
        isNotSignFile: false,
        resolutionChecked: false, resolutionUrl: '', resolutionName: '',
        resolutionTime: '', resolutionAddress: '', resolutionHost: ''
      });
    }
    if (form.customize1Checked) {
      // 上传文件
      let customize1Url = form.customize1Url;
      if (form.customize1File) {
        customize1Url = await upload(form.customize1File, token);
        if (!customize1Url) {
          setAlert({ open: true, message: '文件上传失败' });
          return;
        }
      }
      body = Object.assign(body, {
        isNotSignFile: false,
        customize1Checked: true, customize1Url
      });
    } else {
      body = Object.assign(body, {
        isNotSignFile: false,
        customize1Checked: false, customize1Url: '', customize1Name: ''
      });
    }
    if (form.customize2Checked) {
      // 上传文件
      let customize2Url = form.customize2Url;
      if (form.customize2File) {
        customize2Url = await upload(form.customize2File, token);
        if (!customize2Url) {
          setAlert({ open: true, message: '文件上传失败' });
          return;
        }
      }
      body = Object.assign(body, {
        isNotSignFile: false,
        customize2Checked: true, customize2Url
      });
    } else {
      body = Object.assign(body, {
        isNotSignFile: false,
        customize2Checked: false, customize2Url: '', customize2Name: ''
      });
    }
    return body;
  }

  const upload = async (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', id);
    let res = await fetch(`/api/upload/orderUploadFile`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      body: formData
    });
    res = await res.json();
    console.log('orderUploadFile', res);
    if (res && res.success && res.files && res.files.length > 0) {
      return res.files[0].url;
    }
    return "";
  }

  const signupload = async (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', id);
    let res = await fetch(`/api/upload/singedFile`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      body: formData
    });
    res = await res.json();
    console.log('orderUploadFile', res);
    if (res && res.success && res.files && res.files.length > 0) {
      return res.files[0].url;
    }
    return "";
  }


  // 发送通知
  const handleSendSms = async () => {
    if (!id) {
      return setAlert({ open: true, message: '请先保存订单后再发送短信通知' });
    }
    const token = localStorage.getItem('adminToken');
    try {
      // 查询短信发送统计
      const statsRes = await fetch(`/api/admin/orders/${id}/smsStats`, {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (!statsRes.ok) throw new Error('查询短信统计失败');
      const stats = await statsRes.json();
      const lastTime = stats.last_sms_sent_at
        ? (() => {
            const d = new Date(stats.last_sms_sent_at);
            const pad = n => n.toString().padStart(2, '0');
            return `${d.getFullYear()}年${pad(d.getMonth()+1)}月${pad(d.getDate())}日${pad(d.getHours())}时${pad(d.getMinutes())}分${pad(d.getSeconds())}秒`;
          })()
        : '从未发送';

      const receivers = (stats.sms_receivers || '').split('\n').filter(Boolean).join(', ');

      // 若之前发送过短信才使用自定义确认弹窗
      const proceedSend = async () => {
        try {
          const res = await fetch(`/api/admin/sendSms`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token
            },
            body: JSON.stringify({ id })
          });
          if (res.status === 401 || res.status === 403) {
            setAlert({ open: true, message: '您没有权限执行此操作' });
            return;
          }
          const data = await res.json();
          setAlert({ open: true, message: data.message });
        } catch (err) {
          setAlert({ open: true, message: err.message || '请求失败，请稍后重试' });
        }
      };

      if ((stats.sms_sent_count || 0) > 0) {
        const confirmText = `通知短信已发送过 ${stats.sms_sent_count} 次，共 ${stats.sms_total_messages || 0} 条。\n上次发送是： ${lastTime} 。\n接收号码有：${receivers || '暂无'}\n\n是否继续发送通知短信？`;
        setAlert({ open: true, message: confirmText, onConfirm: proceedSend });
      } else {
        await proceedSend();
      }
    } catch (err) {
      setAlert({ open: true, message: err.message || '请求失败，请稍后重试' });
    }
  };


  const handleChangeUpload = (id) => {
    if (id) {
      const token = localStorage.getItem('adminToken');
      fetch(`/api/admin/orderDetail/${id}`, {
        headers: { Authorization: 'Bearer ' + token }
      })
          .then(res => res.json())
          .then(data => {
            // 添加调试日志
            console.log('=== 数据加载调试信息 ===');
            console.log('订单ID:', id);
            console.log('partners数量:', data.partners ? data.partners.length : 0);
            if (data.partners && data.partners.length > 0) {
              console.log('第一个partner的face_verified_at:', data.partners[0].face_verified_at);
              console.log('第一个partner的face_status:', data.partners[0].face_status);
            }
            console.log('加载的数据:', data);

            // 处理自定义机构类型的显示
            const isCustomType = !['有限责任公司', '有限公司（独资）', '个体工商户', '个人独资企业', '普通合伙企业', '特殊的普通合伙企业', '有限合伙企业', '分支机构/分公司', '农民专业合作社', '党政机关', '事业单位', '部队及军事院校', '社会团体', '群团组织', '基层群众性自治组织'].includes(data.type);
            /* setIsShowSignComplete(data.isShowSignComplete);
             delete data.isShowSignComplete;*/
            setForm({
              ...data,
              partners: data.partners || [],
              type: isCustomType ? '自定义' : data.type,
              customType: isCustomType ? data.type : ''
            });
            /*文件*/
            // 构建文件列表
            const fileList = data.fileList.map(file => ({
              ...file,
              isUpdate: true
            }));
            // 设置文件列表
            setFiles(fileList);

          });
    }
  }

  return (
      <div className="card" style={{
        maxWidth: '800px',
        margin: '20px auto',
        padding: 'clamp(16px, 4vw, 24px)',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <button
            onClick={onBack}
            style={{
              marginBottom: 'clamp(12px, 3vw, 16px)',
              fontSize: 'clamp(14px, 3vw, 16px)',
              padding: 'clamp(8px, 2vw, 12px) clamp(12px, 3vw, 16px)'
            }}
        >返回</button>
        <h2 style={{
          textAlign: 'center',
          color: 'var(--primary-color)',
          marginBottom: 'clamp(16px, 4vw, 24px)',
          fontSize: 'clamp(18px, 4vw, 24px)'
        }}>{id ? '编辑订单' : '新建订单'}</h2>
        <form onSubmit={handleSubmit}>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>机构名称*</label>
            <input
                name="name"
                value={form.name}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.name && <span style={errorStyle}>{errors.name}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>机构类型*</label>
            {form.type === '自定义' ? (
                <input
                    name="type"
                    value={form.customType || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm(prev => ({
                        ...prev,
                        customType: value
                      }));
                    }}
                    onBlur={(e) => {
                      // 当失去焦点且没有内容时，切换回下拉框模式
                      if (!e.target.value.trim()) {
                        setForm(prev => ({
                          ...prev,
                          type: '',
                          customType: ''
                        }));
                      }
                    }}
                    style={{
                      width: '100%',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                    }}
                    className="input"
                    placeholder="请输入自定义机构类型"
                />
            ) : (
                <select
                    name="type"
                    value={form.type}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                    }}
                    className="input"
                >
                  <option value="">请选择</option>
                  <option value="有限责任公司">有限责任公司</option>
                  <option value="有限公司（独资）">有限公司（独资）</option>
                  <option value="个体工商户">个体工商户</option>
                  <option value="个人独资企业">个人独资企业</option>
                  <option value="普通合伙企业">普通合伙企业</option>
                  <option value="特殊的普通合伙企业">特殊的普通合伙企业</option>
                  <option value="有限合伙企业">有限合伙企业</option>
                  <option value="分支机构/分公司">分支机构/分公司</option>
                  <option value="农民专业合作社">农民专业合作社</option>
                  <option value="党政机关">党政机关</option>
                  <option value="事业单位">事业单位</option>
                  <option value="部队及军事院校">部队及军事院校</option>
                  <option value="社会团体">社会团体</option>
                  <option value="群团组织">群团组织</option>
                  <option value="基层群众性自治组织">基层群众性自治组织</option>
                  <option value="自定义">自定义</option>
                </select>
            )}
            {errors.type && <span style={errorStyle}>{errors.type}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>统一社会信用代码*</label>
            <input
                name="credit_code"
                value={form.credit_code}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.credit_code && <span style={errorStyle}>{errors.credit_code}</span>}
          </div>

          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label
                style={labelStyle}
                title="包括但不限于个体工商户的经营者、个人独资企业的投资人、合伙企业称的执行事务合伙人、分公司的负责人。"
            >
              法定代表人*
            </label>
            <input
                name="legal_person"
                value={form.legal_person}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.legal_person && <span style={errorStyle}>{errors.legal_person}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>持股比例（%）</label>
            <input
                name="share_ratio"
                value={form.share_ratio}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
                placeholder="只填数字即可，最大保留4位小数"
            />
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>负责人电话*</label>
            <input
                name="phone"
                type="text"
                value={form.phone}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.phone && <span style={errorStyle}>{errors.phone}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>机构通信地址*</label>
            <input
                name="address"
                value={form.address}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.address && <span style={errorStyle}>{errors.address}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>办理印章名称*</label>
            <SealNameInput
                value={form.seal_names}
                onChange={(value) => setForm(prev => ({ ...prev, seal_names: value }))}
                placeholder="可多选/逗号分隔"
            />
            {errors.seal_names && <span style={errorStyle}>{errors.seal_names}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>业务类型*</label>
            <BusinessTypeInput
                value={form.business_type}
                onChange={(value) => setForm(prev => ({ ...prev, business_type: value }))}
                placeholder="可多选/逗号分隔"
            />
            {errors.business_type && <span style={errorStyle}>{errors.business_type}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>应核验人数*</label>
            <input
                name="should_verify_count"
                value={form.should_verify_count}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.should_verify_count && <span style={errorStyle}>{errors.should_verify_count}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>参与核验人数*</label>
            <input
                name="actual_verify_count"
                value={form.actual_verify_count}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.actual_verify_count && <span style={errorStyle}>{errors.actual_verify_count}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>是否登报声明</label>
            <select
                name="is_announcement"
                value={form.is_announcement}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            >
              <option value={0}>否</option>
              <option value={1}>是</option>
            </select>
          </div>
          {(form.is_announcement === '1' || form.is_announcement === 1) && (
              <>
                <div style={{
                  marginBottom: 'clamp(12px, 3vw, 16px)',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <label style={labelStyle}>见报日期</label>
                  <input
                      name="announcement_date"
                      type="date"
                      value={form.announcement_date ? form.announcement_date.slice(0, 10) : ''}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        fontSize: 'clamp(14px, 3vw, 16px)',
                        padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                      }}
                      className="input"
                  />
                  {errors.announcement_date && <span style={errorStyle}>{errors.announcement_date}</span>}
                </div>
                <div style={{
                  marginBottom: 'clamp(12px, 3vw, 16px)',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <label style={labelStyle}>报刊名称</label>
                  <select
                      name="announcement_paper"
                      value={form.announcement_paper}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        fontSize: 'clamp(14px, 3vw, 16px)',
                        padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                      }}
                      className="input"
                  >
              <option value="">请选择</option>
              <option value="重庆晚报">重庆晚报</option>
              <option value="重庆晨报">重庆晨报</option>
              <option value="重庆日报">重庆日报</option>
              <option value="重庆商报">重庆商报</option>
              <option value="重庆法治报">重庆法治报</option>
            </select>
                  {errors.announcement_paper && <span style={errorStyle}>{errors.announcement_paper}</span>}
                </div>
              </>
          )}
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>是否有法人股东</label>
            <select
                name="has_legal_partner"
                value={form.has_legal_partner}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            >
              <option value={0}>否</option>
              <option value={1}>是</option>
            </select>
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>经办人</label>
            <input
                name="agent"
                value={form.agent}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.agent && <span style={errorStyle}>{errors.agent}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>经办人联系电话</label>
            <input
                name="agent_phone"
                value={form.agent_phone}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
            {errors.agent_phone && <span style={errorStyle}>{errors.agent_phone}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>短信接收号码</label>
            <textarea
                name="sms_receivers"
                value={form.sms_receivers}
                onChange={handleChange}
                style={{
                  width: '100%',
                  height: 'clamp(60px, 8vw, 80px)',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
                placeholder="每行一个手机号"
            />
            {errors.sms_receivers && <span style={errorStyle}>{errors.sms_receivers}</span>}
          </div>
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <label style={labelStyle}>业务备注</label>
            <textarea
                name="remark"
                value={form.remark}
                onChange={handleChange}
                style={{
                  width: '100%',
                  height: 'clamp(60px, 8vw, 80px)',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
            />
          </div>

          <h3 style={{
            color: '#2d8cf0',
            marginTop: 'clamp(20px, 5vw, 24px)',
            fontSize: 'clamp(16px, 4vw, 20px)'
          }}>参与核验人员*</h3>
          {/* 增加注册资金-以万元为单位 */}
          <div style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'column'
          }}>

            <label style={labelStyle}>注册资金（单位：万元）</label>
            <input
                name="registered_capital"
                type="number"
                value={form.registered_capital}
                onChange={handleChange}
                style={{
                  width: '100%',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  padding: 'clamp(8px, 2vw, 12px) clamp(10px, 2.5vw, 16px)'
                }}
                className="input"
                placeholder="只填数字，最大保留4位小数。公司才需要填写，不是公司的请填0。"
            />
          </div>
          
          {errors.partners && <div style={errorStyle}>{errors.partners}</div>}
          <div style={{
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch'
          }}>
            <table style={{
              width: '100%',
              minWidth: '600px',
              background: '#fff',
              borderCollapse: 'collapse',
              borderRadius: 'var(--border-radius)',
              overflow: 'hidden',
              boxShadow: 'var(--box-shadow)',
              fontSize: 'clamp(12px, 3vw, 14px)'
            }}>
              <thead>
              <tr>
                <th style={{ minWidth: 80 }}>是否法人</th>
                <th style={{ minWidth: 120 }}>姓名</th>
                <th style={{ minWidth: 180 }}>身份证号</th>
                <th style={{ minWidth: 120 }}>出资比例(%)</th>
                <th style={{ minWidth: 140 }}>人脸识别状态</th>
                <th style={{ minWidth: 100 }}>操作</th>
              </tr>
              </thead>
              <tbody>
              {form.partners.map((p, idx) => (
                  <React.Fragment key={idx}>
                    <tr>
                      <td>
                        <select
                            value={p.is_legal_person}
                            onChange={e => handlePartnerChange(idx, 'is_legal_person', e.target.value)}
                            className="input"
                            style={{
                              width: '100%',
                              minWidth: 70,
                              fontSize: 'clamp(11px, 2.5vw, 12px)',
                              padding: 'clamp(4px, 1vw, 6px) clamp(6px, 1.5vw, 8px)'
                            }}
                        >
                          <option value={0}>否</option>
                          <option value={1}>是</option>
                        </select>
                      </td>
                      <td>
                        <input
                            value={p.name}
                            onChange={e => handlePartnerChange(idx, 'name', e.target.value)}
                            className="input"
                            style={{
                              width: '100%',
                              minWidth: 100,
                              fontSize: 'clamp(11px, 2.5vw, 12px)',
                              padding: 'clamp(4px, 1vw, 6px) clamp(6px, 1.5vw, 8px)'
                            }}
                        />
                        {errors[`partner_name_${idx}`] && <div style={{ ...errorStyle, marginTop: 4 }}>{errors[`partner_name_${idx}`]}</div>}
                      </td>
                      <td>
                        <input
                            value={p.id_number || ''}
                            onChange={e => handlePartnerChange(idx, 'id_number', e.target.value)}
                            className="input"
                            style={{
                              width: '100%',
                              minWidth: 160,
                              fontSize: 'clamp(11px, 2.5vw, 12px)',
                              padding: 'clamp(4px, 1vw, 6px) clamp(6px, 1.5vw, 8px)'
                            }}
                        />
                        {errors[`partner_id_${idx}`] && <div style={{ ...errorStyle, marginTop: 4 }}>{errors[`partner_id_${idx}`]}</div>}
                      </td>
                      <td>
                        <input
                            type="number"
                            step="0.01"
                            value={p.share_ratio}
                            onChange={e => handlePartnerChange(idx, 'share_ratio', e.target.value)}
                            className="input"
                            style={{
                              width: '100%',
                              minWidth: 80,
                              fontSize: 'clamp(11px, 2.5vw, 12px)',
                              padding: 'clamp(4px, 1vw, 6px) clamp(6px, 1.5vw, 8px)'
                            }}
                        />
                        {errors[`partner_share_${idx}`] && <div style={{ ...errorStyle, marginTop: 4 }}>{errors[`partner_share_${idx}`]}</div>}
                      </td>
                      <td>
                        <select
                            value={p.face_status}
                            onChange={e => handlePartnerChange(idx, 'face_status', e.target.value)}
                            className="input"
                            style={{
                              width: '100%',
                              minWidth: 120,
                              fontSize: 'clamp(11px, 2.5vw, 12px)',
                              padding: 'clamp(4px, 1vw, 6px) clamp(6px, 1.5vw, 8px)'
                            }}
                        >
                          <option value="尚未识别">尚未识别</option>
                          <option value="认证通过">认证通过</option>
                          <option value="认证失败">认证失败</option>
                        </select>
                      </td>
                      <td>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <button
                              type="button"
                              onClick={() => removePartner(idx)}
                              style={{
                                width: '24px',
                                height: '24px',
                                fontSize: '14px',
                                borderRadius: '50%',
                                background: 'transparent',
                                color: '#6c757d',
                                border: '1px solid #6c757d',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                transition: 'all 0.2s ease',
                                minWidth: '24px',
                                maxWidth: '24px',
                                minHeight: '24px',
                                maxHeight: '24px',
                                padding: '0',
                                margin: '0',
                                boxSizing: 'border-box',
                                outline: 'none',
                                lineHeight: '1',
                                textAlign: 'center',
                                verticalAlign: 'middle'
                              }}
                              onMouseOver={(e) => {
                                e.target.style.background = '#6c757d';
                                e.target.style.color = '#fff';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.background = 'transparent';
                                e.target.style.color = '#6c757d';
                              }}
                              title="删除"
                          >-</button>
                        </div>
                      </td>
                    </tr>
                    {/* 法人单位信息行 - 仅当选择"是法人"时显示 */}
                    {(p.is_legal_person === 1 || p.is_legal_person === '1') && (
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                          <td style={{ textAlign: 'center', fontWeight: 'bold', color: '#2d8cf0' }}>法人单位信息</td>
                          <td colSpan="2">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div>
                                <label style={{
                                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                                  color: '#666',
                                  marginBottom: '4px',
                                  display: 'block'
                                }}>单位名称</label>
                                <input
                                    value={p.company_name || ''}
                                    onChange={e => handlePartnerChange(idx, 'company_name', e.target.value)}
                                    className="input"
                                    style={{
                                      width: '100%',
                                      fontSize: 'clamp(10px, 2.5vw, 12px)',
                                      padding: 'clamp(3px, 1vw, 4px) clamp(4px, 1vw, 6px)'
                                    }}
                                    placeholder="请输入法人单位名称"
                                />
                                {errors[`partner_company_name_${idx}`] && <div style={{ ...errorStyle, fontSize: 'clamp(9px, 2vw, 11px)', marginTop: 2 }}>{errors[`partner_company_name_${idx}`]}</div>}
                              </div>
                            </div>
                          </td>
                          <td colSpan="2">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div>
                                <label style={{
                                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                                  color: '#666',
                                  marginBottom: '4px',
                                  display: 'block'
                                }}>统一社会信用代码</label>
                                <input
                                    value={p.company_credit_code || ''}
                                    onChange={e => handlePartnerChange(idx, 'company_credit_code', e.target.value)}
                                    className="input"
                                    style={{
                                      width: '100%',
                                      fontSize: 'clamp(10px, 2.5vw, 12px)',
                                      padding: 'clamp(3px, 1vw, 4px) clamp(4px, 1vw, 6px)'
                                    }}
                                    placeholder="请输入18位统一社会信用代码"
                                />
                                {errors[`partner_company_credit_${idx}`] && <div style={{ ...errorStyle, fontSize: 'clamp(9px, 2vw, 11px)', marginTop: 2 }}>{errors[`partner_company_credit_${idx}`]}</div>}
                              </div>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                    )}
                  </React.Fragment>
              ))}
              </tbody>
            </table>
          </div>
          {/* 全局添加按钮 */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 'clamp(12px, 3vw, 16px)',
            marginBottom: 'clamp(12px, 3vw, 16px)'
          }}>
            <button
                type="button"
                onClick={addPartner}
                style={{
                  width: '28px',
                  height: '28px',
                  fontSize: '16px',
                  borderRadius: '50%',
                  background: 'transparent',
                  color: '#6c757d',
                  border: '1px solid #6c757d',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  transition: 'all 0.2s ease',
                  minWidth: '28px',
                  maxWidth: '28px',
                  minHeight: '28px',
                  maxHeight: '28px',
                  padding: '0',
                  margin: '0',
                  boxSizing: 'border-box',
                  outline: 'none',
                  lineHeight: '1',
                  textAlign: 'center',
                  verticalAlign: 'middle'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#6c757d';
                  e.target.style.color = '#fff';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#6c757d';
                }}
                title="添加参与人"
            >+</button>
          </div>
          {/*签署文件*/}
          <h3 style={{
            color: '#2d8cf0',
            marginTop: 'clamp(20px, 5vw, 24px)',
            fontSize: 'clamp(16px, 4vw, 20px)',
            display: 'flex',
            alignItems: 'center',
            position: 'relative'
          }}>
            签署文件
            <input
                type="checkbox"
                name="isNotSignFile"
                checked={form.isNotSignFile}
                onChange={handleZzjChange}
                style={{
                  margin: 0,
                  width: '14px',
                  height: '14px',
                  accentColor: '#2196f3',
                  cursor: 'pointer',
                  marginLeft: '10px'
                }}
            />
            <label style={{ fontSize: 'clamp(11px, 3vw, 13px)', color: '#333', marginLeft: '5px' }}>无需签署</label>
          </h3>
          {errors.isNotSignFile && <span style={errorStyle}>{errors.isNotSignFile}</span>}

        <div style={{
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch'
          }}>

          {!form.isNotSignFile ? <div style={{
            display: 'flex',
            flexDirection: 'row',
            }}>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <input
                    type="checkbox"
                    name="situationChecked"
                    checked={form.situationChecked}
                    onChange={handleZzjChange}
                    style={{
                      margin: 0,
                      width: '14px',
                      height: '14px',
                      accentColor: '#2196f3',
                      cursor: 'pointer'
                    }}
                />
                <label style={{ ...labelStyle, width: 'auto', marginBottom: '0', marginLeft: '5px' }}>情况说明</label>

                {form.situationUrl ? (
                    <label
                        style={{ ...lookStyle, width: 'auto' }}
                        onClick={() => {
                          const ext = form.situationUrl.split('.').pop().toLowerCase();
                          const isPdf = ['pdf'].includes(ext);
                          const isWord = ['doc', 'docx'].includes(ext);

                           setFileItemShow(true);
                          if (isPdf) {
                              setFileType("pdf");
                          } else if (isWord) {
                              setFileType("docx");
                          }
                          setFileItem(form.situationUrl)
                        }}
                    >
                      查看
                    </label>
                ) : null}
              </div>
            </div>

                <br/>

                

            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <input
                    type="checkbox"
                    name="resolutionChecked"
                    checked={form.resolutionChecked}
                    onChange={handleZzjChange}
                    style={{
                      margin: 0,
                      width: '14px',
                      height: '14px',
                      accentColor: '#2196f3',
                      cursor: 'pointer'
                    }}
                />
                <label style={{ ...labelStyle, width: 'auto', marginBottom: '0', marginLeft: '5px' }}>决议/决定</label>
                {form.resolutionUrl ? (
                    <label
                        style={{ ...lookStyle, width: 'auto' }}
                        onClick={() => {
                          const ext = form.resolutionUrl.split('.').pop().toLowerCase();
                          const isPdf = ['pdf'].includes(ext);
                          const isWord = ['doc', 'docx'].includes(ext);

                           setFileItemShow(true);
                          if (isPdf) {
                              setFileType("pdf");
                          } else if (isWord) {
                              setFileType("docx");
                          }
                          setFileItem(form.resolutionUrl)
                        }}
                    >查看</label>
                ) : null}

              </div>
            </div>
          </div> : null}
          {!form.isNotSignFile ? <div class="zzj-hx-hd" style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'scroll',
          }}>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              marginRight: '10px'
            }}>
              <div
                  onClick={() => {
                    setCurrentSelectFileType('situation');
                    const input = document.getElementById('pick-file-input');
                    input.value = null;
                    if (input) input.click();
                  }}
                  style={{
                    width: '85%',
                    height: '46px',
                    fontSize: 'clamp(10px,1.5vw, 10px)',
                    marginBottom: '0',
                    cursor: 'pointer',
                    border: '2px solid var(--border-color)',
                    borderRadius: 'var(--border-radius)',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px'
                  }}
              >{form.situationName || '请选择文件'}</div>
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row'
            }}>
              <div
                  onClick={() => {
                    setCurrentSelectFileType('resolution');
                    const input = document.getElementById('pick-file-input');
                    input.value = null;
                    if (input) input.click();
                  }}
                  style={{
                    width: '85%',
                    height: '46px',
                    fontSize: 'clamp(10px,1.5vw, 10px)',
                    marginBottom: '0',
                    cursor: 'pointer',
                    border: '2px solid var(--border-color)',
                    borderRadius: 'var(--border-radius)',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px'
                  }}
              >{form.resolutionName || '请选择文件'}</div>
            </div>
          </div> : null}

          {/*di二行*/}
          {!form.isNotSignFile ? <div style={{
            display: 'flex',
            flexDirection: 'row'
          }}>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <input
                    type="checkbox"
                    name="customize1Checked"
                    checked={form.customize1Checked}
                    onChange={handleZzjChange}
                    style={{
                      margin: 0,
                      width: '14px',
                      height: '14px',
                      accentColor: '#2196f3',
                      cursor: 'pointer'
                    }}
                />
                <label style={{ ...labelStyle, width: 'auto', marginBottom: '0', marginLeft: '5px' }}>自定义文件</label>
                {form.customize1Url ? (
                    <label
                        style={{ ...lookStyle, width: 'auto' }}
                        onClick={() => {
                          const ext = form.customize1Url.split('.').pop().toLowerCase();
                          const isPdf = ['pdf'].includes(ext);
                          const isWord = ['doc', 'docx'].includes(ext);

                           setFileItemShow(true);
                          if (isPdf) {
                              setFileType("pdf");
                          } else if (isWord) {
                              setFileType("docx");
                          }
                          setFileItem(form.customize1Url)
                        }}
                    >查看</label>
                ) : null}

              </div>

            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <input
                    type="checkbox"
                    name="customize2Checked"
                    checked={form.customize2Checked}
                    onChange={handleZzjChange}
                    style={{
                      margin: 0,
                      width: '14px',
                      height: '14px',
                      accentColor: '#2196f3',
                      cursor: 'pointer'
                    }}
                />
                <label style={{ ...labelStyle, width: 'auto', marginBottom: '0', marginLeft: '5px' }}>自定义文件2</label>
                {form.customize2Url ? (
                    <label
                        style={{ ...lookStyle, width: 'auto' }}
                        onClick={() => {
                          const ext = form.customize2Url.split('.').pop().toLowerCase();
                          const isPdf = ['pdf'].includes(ext);
                          const isWord = ['doc', 'docx'].includes(ext);

                           setFileItemShow(true);
                          if (isPdf) {
                              setFileType("pdf");
                          } else if (isWord) {
                              setFileType("docx");
                          }
                          setFileItem(form.customize2Url);
                        }}
                    >查看</label>
                ) : null}

              </div>
            </div>
          </div> : null}
          {!form.isNotSignFile ? <div class="zzj-hx-hd" style={{
            marginBottom: 'clamp(12px, 3vw, 16px)',
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'scroll'
          }}>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              marginRight: '10px'
            }}>
              <div
                  onClick={() => {
                    setCurrentSelectFileType('customize1');
                    const input = document.getElementById('pick-file-input');
                    input.value = null;
                    if (input) input.click();
                  }}
                  style={{
                    width: '85%',
                    height: '46px',
                    fontSize: 'clamp(10px,1.5vw, 10px)',
                    marginBottom: '0',
                    cursor: 'pointer',
                    border: '2px solid var(--border-color)',
                    borderRadius: 'var(--border-radius)',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px'
                  }}
              >{form.customize1Name || '请选择文件'}</div>
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row'
            }}>
              <div
                  onClick={() => {
                    setCurrentSelectFileType('customize2');
                    const input = document.getElementById('pick-file-input');
                    input.value = null;
                    if (input) input.click();
                  }}
                  style={{
                    width: '85%',
                    height: '46px',
                    fontSize: 'clamp(10px,1.5vw, 10px)',
                    marginBottom: '0',
                    cursor: 'pointer',
                    border: '2px solid var(--border-color)',
                    borderRadius: 'var(--border-radius)',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px'
                  }}
              >{form.customize2Name || '请选择文件'}</div>
            </div>
          </div> : null}

          {!form.isNotSignFile && form.resolutionChecked ? <div class="zzj-hx-hd" >


            <div style={{
              flex: 1,
              marginBottom: 'clamp(12px, 3vw, 16px)',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}>
              <label style={{ ...labelStyle, width: '100px', marginBottom: '0', textAlign: 'left', marginRight: '5px', fontSize: '12px' }}>会议/决定日期</label>
              <input
                  name="resolutionTime"
                  value={form.resolutionTime}
                  onChange={handleChange}
                  style={{
                    width: '80%',
                    fontSize: 'clamp(13px, 3vw, 16px)',
                    marginBottom: '0'
                  }}
                  type="date"
                  className="input"
              />
            </div>
            
            <div style={{
              flex: 1,
              marginBottom: 'clamp(12px, 3vw, 16px)',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}>
              <label style={{ ...labelStyle, width: '100px', marginBottom: '0', textAlign: 'left', marginRight: '5px', fontSize: '12px' }}>会议地点</label>
              <input
                  name="resolutionAddress"
                  value={form.resolutionAddress}
                  onChange={handleChange}
                  style={{
                    width: '80%',
                    fontSize: 'clamp(13px, 3vw, 16px)',
                    marginBottom: '0'
                  }}
                  className="input"
              />
            </div>

            <br/>

            <div style={{
              flex: 1,
              marginBottom: 'clamp(12px, 3vw, 16px)',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}>
              <label style={{ ...labelStyle, width: '100px', marginBottom: '0', textAlign: 'left', marginRight: '5px', fontSize: '12px' }}>主持人</label>
              <input
                  name="resolutionHost"
                  value={form.resolutionHost}
                  onChange={handleChange}
                  style={{
                    width: '80%',
                    fontSize: 'clamp(13px, 3vw, 16px)',
                    marginBottom: '0'
                  }}
                  className="input"
              />
            </div>
            <br/>

          </div> : null}
          {errors.resolutionChecked && !form.isNotSignFile && form.resolutionChecked ? <span style={errorStyle}>{errors.resolutionChecked}</span> : null}
        </div>
          {/*已签署文件上传*/}
          <div style={{
            color: '#2d8cf0',
            marginTop: 'clamp(20px, 5vw, 24px)',
            fontSize: 'clamp(16px, 4vw, 20px)',
            display: 'flex',
            alignItems: 'center',
            position: 'relative'
          }}>
            <h3 style={{
              color: '#2d8cf0',
              marginTop: 'clamp(20px, 5vw, 24px)',
              fontSize: 'clamp(16px, 4vw, 20px)'
            }}>已签章文件</h3>

            {/* isShowSignComplete */}
            <div style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              position: 'absolute',
              right: '0'
            }}>
              <input
                  type="checkbox"
                  name="is_sign_complete"
                  checked={form.is_sign_complete}
                  onChange={handleZzjChange}
                  style={{
                    margin: 0,
                    width: '14px',
                    height: '14px',
                    accentColor: '#2196f3',
                    cursor: 'pointer',
                    marginLeft: '10px'
                  }}
              />
              <label style={{ fontSize: 'clamp(11px, 3vw, 13px)', color: '#333', marginLeft: '5px' }}>签名完成</label>
            </div>
          </div>

          <div style={{
            padding: '16px',
            border: '1px solid #e8e8e8',
            borderRadius: '4px',
            backgroundColor: '#fafafa',
            marginTop: '16px'
          }}>
            {/* 隐藏的文件输入 */}
            <input
                id="pick-file-input2"
                style={{ display: 'none' }}
                type="file"
                accept=".doc,.docx,.pdf"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setFiles(prev => {
                    const newFiles = [...prev];
                    newFiles[activeFileIndex] = {
                      ...newFiles[activeFileIndex], // 保留其他属性
                      fileName: file.name,
                      fileContent:file,
                      isUpdate:false
                    };
                    return newFiles;
                  });
                }}
            />

            {/* 文件列表 - 当有文件时显示 */}
            {files && files.length > 0 ? (
                <div style={{ marginBottom: '16px' }}>
                  {files.map((item, index) =>(<div
                              key={item.fileUrl || index}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px',
                                backgroundColor: '#fff',
                                border: '1px solid #e8e8e8',
                                borderRadius: '4px',
                                marginBottom: '8px'
                              }}
                          >
                            {/* 文件名 */}
                            <div
                                style={{
                                  fontSize: '0.8em',
                                  flex: 1,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  color: item.fileUrl ? '#1890ff' : '#999'
                                }}
                            >
                              {item.fileName || '未上传文件'}
                            </div>

                            {/* 上传/替换按钮 */}
                            <button
                                type="button"
                                style={{
                                  padding: '0.5em',
                                  fontSize: '0.8em',
                                  borderRadius: '4px',
                                  background: item.fileUrl ? '#f0f0f0' : '#1890ff',
                                  color: item.fileUrl ? '#666' : '#fff',
                                  border: 'none',
                                  cursor: 'pointer',
                                  marginRight:'0.2em'
                                }}
                                onClick={() => {
                                  setActiveFileIndex(index);
                                  const input = document.getElementById('pick-file-input2');
                                  input.value = ''; // 更安全的清空方式
                                  input.click();
                                }}
                                title={item.fileUrl ? "重新上传" : "上传文件"}
                            >
                              {item.fileUrl ? "重新上传" : "上传"}
                            </button>

                            {/* 操作按钮区域 */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {/* 查看按钮 - 只有当有文件时才显示 */}
                              {item.isUpdate && (
                                  <button
                                      type="button"
                                      style={{
                                        padding: '0.5em',
                                        fontSize: '0.8em',
                                        borderRadius: '4px',
                                        background: '#1890ff',
                                        color: '#fff',
                                        border: 'none',
                                        cursor: 'pointer',
                                      }}
                                      // onClick={() => {
                                      //   window.open(item.fileUrl);
                                      // }}

                                      onClick={() => {
                                        const ext = item.fileUrl.split('.').pop().toLowerCase();
                                        const isPdf = ['pdf'].includes(ext);
                                        const isWord = ['doc', 'docx'].includes(ext);
                                        console.log("已签章文件",item.fileUrl);
                                        setFileItemShow(true);
                                        if (isPdf) {
                                            setFileType("pdf");
                                        } else if (isWord) {
                                            setFileType("docx");
                                        }
                                        setFileItem(item.fileUrl)
                                      }}
                                      title="查看文件"
                                  >
                                    查看
                                  </button>
                              )}

                              {/* 添加按钮 */}
                              <button
                                  type="button"
                                  style={{
                                    width: '1em',
                                    height: '1em',
                                    fontSize: '1em',
                                    borderRadius: '50%',
                                    background: 'transparent',
                                    color: '#6c757d',
                                    border: '1px solid #6c757d',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    transition: 'all 0.2s ease',
                                    minWidth: '1em',
                                    maxWidth: '1em',
                                    minHeight: '1em',
                                    maxHeight: '1em',
                                    padding: '0',
                                    margin: '0',
                                    boxSizing: 'border-box',
                                    outline: 'none',
                                    lineHeight: '1',
                                    textAlign: 'center',
                                    verticalAlign: 'middle'
                                  }}
                                  onClick={() => {
                                    const newFiles = [...files];
                                    newFiles.splice(index + 1, 0, { fileName: '', fileUrl: '' });
                                    setFiles(newFiles);
                                  }}
                                  title="添加文件"
                              >
                                +
                              </button>

                              {/* 删除按钮 */}
                              <button
                                  type="button"
                                  onClick={() => {
                                    // 换一种思路,将所有删除的index下标存储下来,在保存的时候在进行删除
                                    setFilesDelIndex([...filesDelIndex, index]);
                                    console.log(filesDelIndex);
                                    // 直接在界面上删除
                                    setFiles(files.filter((_, i) => i !== index));
                                  }}
                                  style={{
                                    width: '1em',
                                    height: '1em',
                                    fontSize: '14px',
                                    borderRadius: '50%',
                                    background: 'transparent',
                                    color: '#6c757d',
                                    border: '1px solid #6c757d',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    transition: 'all 0.2s ease',
                                    minWidth: '1em',
                                    maxWidth: '1em',
                                    minHeight: '1em',
                                    maxHeight:'1em',
                                    padding: '0',
                                    margin: '0',
                                    boxSizing: 'border-box',
                                    outline: 'none',
                                    lineHeight: '1',
                                    textAlign: 'center',
                                    verticalAlign: 'middle'
                                  }}
                                  title="删除"
                              >
                                -
                              </button>
                            </div>
                          </div>
                      )
                  )}
                </div>
            ) : (
                /* 空状态提示 */
                <div style={{
                  textAlign: 'center',
                  color: '#999',
                  padding: '12px',
                  fontSize: '14px',
                  marginBottom: '16px'
                }}>
                  暂无已上传文件
                </div>
            )}

            {/* 底部添加按钮 - 当没有文件时显示 */}
            {(!files || files.length === 0) && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button
                      type="button"
                      style={{
                        width: '24px',
                        height: '24px',
                        fontSize: '14px',
                        borderRadius: '50%',
                        background: 'transparent',
                        color: '#6c757d',
                        border: '1px solid #6c757d',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        transition: 'all 0.2s ease',
                        minWidth: '24px',
                        maxWidth: '24px',
                        minHeight: '24px',
                        maxHeight: '24px',
                        padding: '0',
                        margin: '0',
                        boxSizing: 'border-box',
                        outline: 'none',
                        lineHeight: '1',
                        textAlign: 'center',
                        verticalAlign: 'middle'
                      }}
                      onClick={() => {
                        setFiles(prev => [...(prev || []), { fileName: '', fileUrl: '' }]);
                      }}
                      title="添加文件"
                  >
                    +
                  </button>
                </div>
            )}
          </div>

          {/*已签署文件上传结束*/}

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 'clamp(12px, 3vw, 16px)',
            marginTop: 'clamp(20px, 5vw, 30px)',
            paddingTop: 'clamp(12px, 3vw, 20px)',
            borderTop: '1px solid #e9ecef'
          }}>
            <button
                type="button"
                onClick={onBack}
                style={{
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 20px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  minWidth: '100px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#0056b3';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#007bff';
                  e.target.style.transform = 'translateY(0)';
                }}
            >
              返回
            </button>
            <button
                type="submit"
                style={{
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 20px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  minWidth: '100px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#0056b3';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#007bff';
                  e.target.style.transform = 'translateY(0)';
                }}
            >
              保存
            </button>

            <button
                type="button"
                onClick={handleSendSms}
                style={{
                  background: '#17a2b8',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
                  cursor: 'pointer',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content'
                }}
              >
                发送通知
              </button>

          </div>
        </form >

        {/* 弹出框 */}
                {fileItemShow && (
                    <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    >
                    <div
                        style={{
                        width: "95%",
                        height: "65%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        overflow: "auto",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        }}
                    >
                        {/* 关闭按钮 */}
                        <div style={{ padding: "10px", textAlign: "right" }}>
                            <text style={{
                            display: 'inline-block',
                            textAlign: 'left',
                            padding: '5px 5px',
                            fontSize: '20px',
                            color: '#888',
                            marginRight: '10vw'
                          }}>💡可放大屏幕阅读</text>
                        <button onClick={() => setFileItemShow(false)}>关闭</button>
                        </div>

                        {/* 文件预览 */}
                        {/* 文件预览 */}
                        <div className="flex-1 overflow-hidden" id='pdfForPreview' ref={pdfForPreview} style={{ flex: 1, borderTop: "1px solid #ccc", height: '100%', width: '100%' }}>
                            { fileType != 'pdf' ? 
                                ( <DocumentFileViewer 
                                    fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`}
                                    fileType={fileType}
                                    />
                                )
                                : 
                                (
                                    <Worker workerUrl={`${window.location.origin}/pdf.worker.min.js`}>
                                        <Viewer fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`} />
                                    </Worker>
                                )
                            }
                        </div>
                    </div>
                </div>
                )}
        {/* {Object.keys(errors).some(key => key.startsWith('partner_face_')) && (
        <div style={errorStyle}>必须上传对应参与核验人员的底库照</div>
      )} */}
        < div style={{ marginTop: 10, color: msg === '保存成功' ? 'green' : 'var(--danger-color)' }
        }> {msg}</div >
        <SimpleAlert open={alert.open} message={alert.message} onClose={() => setAlert({ ...alert, open: false, onConfirm: null })} onConfirm={alert.onConfirm} />
        <input id="pick-file-input" style={{ display: 'none' }} type="file" accept=".doc,.docx,.pdf" onChange={(e) => {
          const file = e.target.files[0];
          if (!file) return;
          if (currentSelectFileType === 'resolution') {
            setForm(prev => ({ ...prev, resolutionChecked: true, resolutionFile: file, resolutionUrl: '', resolutionName: file.name }));
          } else if (currentSelectFileType === 'situation') {
            setForm(prev => ({ ...prev, situationChecked: true, situationFile: file, situationUrl: '', situationName: file.name }));
          } else if (currentSelectFileType === 'customize1') {
            setForm(prev => ({ ...prev, customize1Checked: true, customize1File: file, customize1Url: '', customize1Name: file.name }));
          } else if (currentSelectFileType === 'customize2') {
            setForm(prev => ({ ...prev, customize2Checked: true, customize2File: file, customize2Url: '', customize2Name: file.name }));
          }
        }} />


      </div >
  );
}
